import { takeEvery, spawn } from 'redux-saga/effects';

import { CAMPAIGN } from 'services/actions/campaignActions';
import { requestProducts } from 'services/actions/productsActions';
import { fetchCartData } from '../app/sale';
import { fetchProducts } from '../fetchProducts/fetchProducts';
import { fetchCampaignData, fetchCustomizeLastQuestion } from '../app/base';

const { REQUEST_BOOST_DATA } = CAMPAIGN;

// worker sagas
export function* fetchBoostData() {
  // using spawn so sagas run independently
  yield spawn(fetchCartData);
  yield spawn(fetchCampaignData);
  yield spawn(
    fetchProducts,
    requestProducts({
      offset: null,
      selectedCategoryId: null,
      selectedSort: 'DEFAULT',
    })
  );
  yield spawn(fetchCustomizeLastQuestion);
}

// watcher sagas
export function* watchFetchBoostData() {
  yield takeEvery(REQUEST_BOOST_DATA, fetchBoostData);
}
